import video from "src/utils/video"

/**
 * 
 * @param {string} uri 
 */
const videoURIParser = (uri) => {
    const parser = video.find(it => it.test(uri))
    if (!parser) return uri

    return parser.parse(uri)
    
}

export default ({url}) => {
    return <div style={{width: "100%", height: "100%"}}>
        <iframe src={`${videoURIParser(url)}`}  width="100%" height="100%" frameBorder="0" autoPlay="true" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay"/>
    </div>
}

export const largeVideoModalProps = {
    dismissHTML: "X",
    dismissStyle: {
        background: "rgb(255 89 89)",
        width: "4%",
        textAlign: "center",
        borderRadius: "0px 10px 0px 10px",
        right: "0%",
        fontSize: "25px"
    },
    style: {
        overflow: "hidden",
        borderRadius: "10px",
        top: "-6.5%",
        left: "-.5%",
        aspectRatio: "16/9",
        background: "#000",
        width: "70.7%"
    }
}

export const defaultModal = {
    dismissHTML: "X",
    dismissStyle: {
        color: "#fff",
        fontSize: "25px"
    },
    style: {
        textAlign:  "center",
        background: "#8f38de",
        color: "#fff",
        padding: "2em 3.5em",
        borderRadius: "10px",
       // minWidth: "500px",
       // width: '40%'
    }
}
